var map = {
	"./cosmo-hotel-img.png": 7465,
	"./header-bkg.png": 2939,
	"./home-img-1.png": 4410,
	"./home-img-2.png": 4993,
	"./home-img-3.png": 3864,
	"./home-img-4.png": 6503,
	"./home-img-5.png": 7278,
	"./homepage-img-main.png": 7907,
	"./icon-area-personale.png": 6686,
	"./icon-contacts.png": 472,
	"./icon-dress.png": 1902,
	"./icon-foto-e-video.png": 1001,
	"./icon-home.png": 7690,
	"./icon-news.png": 6317,
	"./icon-program.png": 8859,
	"./mood-img.png": 4864,
	"./retro.png": 5131,
	"./teams-bkg.png": 8794
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4504;